// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Belt_MapString from "@rescript/runtime/lib/es6/Belt_MapString.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as LumiGeolocation from "lumi-rescript/lib/es6/src/LumiGeolocation.res.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Types$LumiDocuments from "./Types.res.js";
import * as Timelines$LumiDocuments from "./Types/Timelines.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";
import * as FacilityServer$LumiDocuments from "./FacilityServer.res.js";

let options = [
  "Planned",
  "InitialTrainingPeriod",
  "Operational",
  "Archived"
];

let stringCodec = StringCodec.anySumAsString(options, undefined);

let jsonCodec = LumiJzon.stringCodec(stringCodec);

function Facility$FacilityOperationalState(props) {
  let value = props.value;
  let tmp;
  switch (value) {
    case "Planned" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "person-digging"
        }),
        className: "icon has-text-warning"
      });
      break;
    case "InitialTrainingPeriod" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "wand-magic-sparkles"
        }),
        className: "icon has-text-success"
      });
      break;
    case "Operational" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "gears"
        }),
        className: "icon has-text-success"
      });
      break;
    case "Archived" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "broom"
        }),
        className: "icon has-text-grey-light"
      });
      break;
  }
  return JsxRuntime.jsxs("span", {
    children: [
      tmp,
      JsxRuntime.jsx("span", {
        children: stringCodec.toString(value)
      })
    ],
    className: "icon-text"
  });
}

let FacilityOperationalState = {
  options: options,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  make: Facility$FacilityOperationalState
};

let jsonCodec$1 = Jzon.object2(param => [
  param.description,
  param.identifier
], param => ({
  TAG: "Ok",
  _0: {
    description: param[0],
    identifier: param[1]
  }
}), Jzon.field("description", Jzon.string), Jzon.field("identifier", Jzon.string));

let NprOpenData = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object2(param => [
  param.identifier,
  param.enableUpload
], param => ({
  TAG: "Ok",
  _0: {
    identifier: param[0],
    enableUpload: param[1]
  }
}), Jzon.field("identifier", Jzon.string), Jzon.field("enableUpload", Jzon.bool));

let HbfUploadSpec = {
  jsonCodec: jsonCodec$2
};

let jsonCodec$3 = Jzon.object2(param => [
  param.identifier,
  param.enableUpload
], param => ({
  TAG: "Ok",
  _0: {
    identifier: param[0],
    enableUpload: param[1]
  }
}), Jzon.field("identifier", Jzon.string), Jzon.field("enableUpload", Jzon.bool));

let FmsUploadSpec = {
  jsonCodec: jsonCodec$3
};

let jsonCodec$4 = LumiJzon.taggedVariant(source => {
  if (source.TAG === "ProRail") {
    return [
      "ProRail",
      Jzon.encodeWith(source._0, Jzon.string)
    ];
  } else {
    return [
      "Abel",
      Jzon.encodeWith(source._0, Jzon.string)
    ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "Abel" :
      return Stdlib_Result.map(Jzon.decodeWith(json, Jzon.string), uuid => ({
        TAG: "Abel",
        _0: uuid
      }));
    case "ProRail" :
      return Stdlib_Result.map(Jzon.decodeWith(json, Jzon.string), uuid => ({
        TAG: "ProRail",
        _0: uuid
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let DownloadSource = {
  jsonCodec: jsonCodec$4
};

let jsonCodec$5 = Jzon.object3(param => [
  param.source,
  param.sensorLow,
  param.sensorHigh
], param => ({
  TAG: "Ok",
  _0: {
    source: param[0],
    sensorLow: param[1],
    sensorHigh: param[2]
  }
}), Jzon.field("source", jsonCodec$4), Jzon.field("sensorLow", Document$LumiStore.Key.jsonCodec()), Jzon.field("sensorHigh", Document$LumiStore.Key.jsonCodec()));

let HighLowSource = {
  jsonCodec: jsonCodec$5
};

let jsonCodec$6 = Jzon.object3(param => [
  param.cityCode,
  param.locationId,
  param.sensor
], param => ({
  TAG: "Ok",
  _0: {
    cityCode: param[0],
    locationId: param[1],
    sensor: param[2]
  }
}), Jzon.field("cityCode", Jzon.int), Jzon.field("locationId", Jzon.string), Jzon.field("sensor", Document$LumiStore.Key.jsonCodec()));

let VeiligStallenSource = {
  jsonCodec: jsonCodec$6
};

let jsonCodec$7 = LumiJzon.taggedVariant(source => {
  if (source.TAG === "HighLow") {
    return [
      "HighLow",
      Jzon.encodeWith(source._0, jsonCodec$5)
    ];
  } else {
    return [
      "VeiligStallen",
      Jzon.encodeWith(source._0, jsonCodec$6)
    ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "HighLow" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$5), highLow => ({
        TAG: "HighLow",
        _0: highLow
      }));
    case "VeiligStallen" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$6), veiligStallen => ({
        TAG: "VeiligStallen",
        _0: veiligStallen
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let Source = {
  jsonCodec: jsonCodec$7
};

let jsonCodec$8 = Jzon.object3(param => [
  param.source,
  param.group,
  param.enableDownload
], param => ({
  TAG: "Ok",
  _0: {
    source: param[0],
    group: param[1],
    enableDownload: param[2]
  }
}), Jzon.field("source", jsonCodec$7), Jzon.field("group", SensorGroups$LumiStaticData.GroupFullId.jsonCodec), Jzon.field("enableDownload", Jzon.bool));

let DownloadSpec = {
  jsonCodec: jsonCodec$8
};

let prorailNameLabel = "ProRail";

let localNameLabel = "Local";

let jsonCodec$9 = Jzon.object17(param => [
  param.name,
  param.labelledNames,
  param.geoLocation,
  param.address,
  param.group,
  param.extraStatsGroups,
  param.servers,
  param.operationalState,
  param.operationalSince,
  param.openingTimes,
  param.inExternalApi,
  param.nprOpenData,
  param.hbfUploadSpec,
  param.fmsUploadSpec,
  param.downloadSpec,
  param.defaultMap,
  param.maps
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    labelledNames: param[1],
    geoLocation: param[2],
    address: param[3],
    group: param[4],
    extraStatsGroups: param[5],
    servers: param[6],
    operationalState: param[7],
    operationalSince: param[8],
    openingTimes: param[9],
    inExternalApi: param[10],
    nprOpenData: param[11],
    hbfUploadSpec: param[12],
    fmsUploadSpec: param[13],
    downloadSpec: param[14],
    defaultMap: param[15],
    maps: param[16]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("labelledNames", LumiJzon.mapString(Jzon.string)), Jzon.field("geoLocation", LumiGeolocation.jsonCodec), Jzon.field("address", Jzon.string), Jzon.field("group", Jzon.nullable(SensorGroups$LumiStaticData.GroupFullId.jsonCodec)), Jzon.field("extraStatsGroups", Jzon.array(SensorGroups$LumiStaticData.GroupFullId.jsonCodec)), Jzon.field("servers", LumiJzon.set(Document$LumiStore.Key.jsonCodec(), FacilityServer$LumiDocuments.Schema.CmpKey)), Jzon.field("operationalState", jsonCodec), Jzon.field("operationalSince", Jzon.nullable(LumiDate.DateTime.jsonCodec)), Jzon.field("openingTimes", Jzon.nullable(Timelines$LumiDocuments.Timeline.jsonCodec(Jzon.string, Types$LumiDocuments.OpenClosedState.jsonCodec))), Jzon.field("inExternalApi", Jzon.bool), Jzon.field("nprOpenData", Jzon.nullable(jsonCodec$1)), Jzon.field("hbfUploadSpec", Jzon.nullable(jsonCodec$2)), Jzon.field("fmsUploadSpec", Jzon.nullable(jsonCodec$3)), Jzon.field("downloadSpec", Jzon.nullable(jsonCodec$8)), Jzon.field("defaultMap", Jzon.nullable(Document$LumiStore.Key.jsonCodec())), Jzon.field("maps", Jzon.array(Document$LumiStore.Key.jsonCodec())));

function getLocalName(f) {
  return Belt_MapString.getWithDefault(f.labelledNames, localNameLabel, f.name);
}

function getProrailName(f) {
  return Belt_MapString.getWithDefault(f.labelledNames, prorailNameLabel, f.name);
}

let Facility = {
  prorailNameLabel: prorailNameLabel,
  localNameLabel: localNameLabel,
  jsonCodec: jsonCodec$9,
  getLocalName: getLocalName,
  getProrailName: getProrailName,
  getDashboardName: getProrailName
};

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "facility",
  jsonCodec: jsonCodec$9,
  icon: "industry",
  readOnly: false
});

export {
  FacilityOperationalState,
  NprOpenData,
  HbfUploadSpec,
  FmsUploadSpec,
  DownloadSource,
  HighLowSource,
  VeiligStallenSource,
  Source,
  DownloadSpec,
  Facility,
  Schema,
}
/* stringCodec Not a pure module */
